var initialize = require('./extrax2-webadmin.initialize.js');
var JsNumberFormatter = require('./jsnumberformatter.js').JsNumberFormatter;
var JsNumberFormatterLocales = require('./jsnumberformatter.locale.js').JsNumberFormatterLocales;

module.exports.GLOBALS  =
{
	programmaticClick: false,
	programmaticChange: false,
	elementToClickAfterSave: null,
	secondElementToClickAfterSave: null, // Für Vorschau bei DataViews muss erst das Element aus Liste angeklickt werden
	showValidationErrorMessageBox: true,
	runningAjaxRequests: [],
	runningTableClickRequests: [],
	runningSaveRequest: null,
	runningCompletenessRequest: null,
	startNewCompletenessRequest: false,
	timerIntegrity: null,
	integrityControlList: [],
	subControlsList: [],
	contentDetailMasterFields: [],
	contentDetailCourseFields: [],
	ignoreFieldsNameArray: [],
	importRunning: false,
	participantToShow: null,
	examinationToShow: null,
	modelToShow: null,
	showAllActivePatients: null,
	searchString: '',
	mailsSelected: [],
	mailsUnselected: [],
	mailAttachments: [],
};

function updateGlobals(key, value) {
	this.GLOBALS[key] = value;
};

function isUndefined(element) {
	return element === null || element === 'undefined' || typeof (element) === 'undefined' || typeof (element) === false;
}

function calculateAge(birth_date) {

	var age = round(moment().diff(moment(birth_date), 'years', true), 1);

	if (age % 1 === 0) {
		var options = new JsNumberFormatterLocales.formatOptions($('#locale').data().locale.split('-')[0]);
		return numberToString(age) + options.decimalSeperatorStr + '0';
	}
	return numberToString(age);
}

function round(value, exp) {
	if (typeof exp === 'undefined' || +exp === 0)
		return Math.round(value);

	value = +value;
	exp = +exp;

	if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
		return NaN;

	// Shift
	value = value.toString().split('e');
	value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

	// Shift back
	value = value.toString().split('e');
	return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
}

function complementDateString(date, format) {

	var dateArray = date.split('.');

	if (/^MM\/YYYY$/.test(format)) {
		dateArray = date.split('/');
	}

	if (/^DD\.MM\.YYYY$/.test(format)) {

		if (dateArray[0].length === 1) {
			dateArray[0] = '0' + dateArray[0];
		}
		if (dateArray.length > 1 && dateArray[1].length === 1) {
			dateArray[1] = '0' + dateArray[1];
		}

		if (dateArray.length === 1 || dateArray[1] == '') {
			dateArray[1] = moment().format('MM.YYYY');
		} else {
			if (dateArray.length === 2 || (dateArray.length > 2 && dateArray[dateArray.length - 1] == '')) {
				if (dateArray.length === 2) {
					dateArray[dateArray.length] = moment().format('YYYY');
				} else {
					dateArray[dateArray.length - 1] = moment().format('YYYY');
				}
			} else if (dateArray.length > 2 && dateArray[dateArray.length - 1].length === 2) {
				try {
					var year = parseInt(dateArray[dateArray.length - 1]);
					dateArray[dateArray.length - 1] = (year + (year > (parseInt(moment().format('YY')) + 1) ? 1900 : 2000)).toString();
				} catch (NaNError) {
				}
			}
		}

		date = dateArray.join('.');
	} else if (/^MM\/YYYY$/.test(format)) {

		if (dateArray[0].length === 1) {
			dateArray[0] = '0' + dateArray[0];
		}
		if (dateArray.length === 1) {
			dateArray[1] = moment().format('YYYY');
		} else if (dateArray.length > 1 && dateArray[dateArray.length - 1].length === 2) {
			try {
				var year = parseInt(dateArray[dateArray.length - 1]);
				dateArray[dateArray.length - 1] = (year + (year > (parseInt(moment().format('YY')) + 1) ? 1900 : 2000)).toString();
			} catch (NaNError) {
			}
		}

		date = dateArray.join('/');
	} else if (/^YYYY$/.test(format)) {

		if (dateArray.length === 1 && dateArray[dateArray.length - 1].length === 2) {
			try {
				var year = parseInt(dateArray[dateArray.length - 1]);
				dateArray[dateArray.length - 1] = (year + (year > (parseInt(moment().format('YY')) + 1) ? 1900 : 2000)).toString();
			} catch (NaNError) {
			}
		}

		date = dateArray.join('/');
	}

	return date;
}

function complementTimeString(time) {

	if (time === '') {
		return time;
	}
	var timeArray = time.split(':');
	if (timeArray.length === 1) {
		if (timeArray[0].length === 1) {
			timeArray[0] = '0' + timeArray[0];
		}
	}
	if (timeArray.length === 1 || timeArray[1] == '') {
		timeArray[1] = '00';
	} else {
		if (timeArray[1].length === 1) {
			timeArray[1] = '0' + timeArray[1];
		}
	}
	
	return timeArray.join(':');
}

function dateToString(date) {
	if (date === null) {
		return '';
	}
	return moment(date).format('YYYY-MM-DD');
}

function dateToTimeString(date) {
	return moment(date).format('YYYY-MM-DD HH:mm:ss');
}

function dateToTimepickerString(date) {
	return moment(date).format('HH:mm');
}

function stringToDate(dateString) {
	if (dateString === null || dateString === '' || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
		return null;
	}
	if (dateString === 'today') {
		return moment().toDate();
	}
	return moment(dateString).toDate();
}

function stringToUTCDate(dateString) {

	if (dateString === null || dateString === '' || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
		return null;
	}

	return moment.utc(dateString).valueOf();
}

function dateToLocaleFormatString(dateString, format) {
	if (dateString === null || dateString === '') {
		return '';
	}

	return moment(dateString).locale($('#locale').data().locale).format(format);
}

function dateToLocaleString(dateString) {
	if (dateString === null || dateString === '') {
		return '';
	}

	return moment(dateString).locale($('#locale').data().locale).format('L');
}

function dateToLocaleTimeString(dateString, asHTML) {
	var addHTML = true;
	if (!isUndefined(asHTML)) {
		addHTML = asHTML;
	}
	if (dateString === null || dateString === '') {
		return '';
	}

	if (addHTML) {
		return moment(dateString).locale($('#locale').data().locale).format('L') + '&nbsp;&nbsp;' + moment(dateString).locale($('#locale').data().locale).format('LT');
	}
	return moment(dateString).locale($('#locale').data().locale).format('L') + '  ' + moment(dateString).locale($('#locale').data().locale).format('LTS');
}

function dateToLocaleLongTimeString(dateString) {
	if (dateString === null || dateString === '') {
		return '';
	}

	return moment(dateString).locale($('#locale').data().locale).format('LLLL');
}

function getLocaleDateFormat() {
	return moment().locale($('#locale').data().locale)._locale._longDateFormat.L;
}

function getLocaleDateFormatMask(dateFormat) {
	if (!isUndefined(dateFormat)) {
		return dateFormat.replace('DD', '99').replace('MM', '99').replace('YYYY', '9999');
	}
	return '?' + moment().locale($('#locale').data().locale)._locale._longDateFormat.L.replace('DD', '99').replace('MM', '99').replace('YYYY', '9999');
}

function getExaminationDateFormat() {
	if (!isUndefined($('#content').find('.tt-data-collection-type').select2('data'))) {
		return $('#content').find('.tt-data-collection-type').select2('data').examinationdateFormat;
	}
	return '';
}

function getExaminationDateString(date, format) {
	var dateToDisplay = null;
	if (format === 'date') {
		dateToDisplay = dateToLocaleString(date);
	} else if (format === 'year') {
		dateToDisplay = moment(date).locale($('#locale').data().locale).format('YYYY');
	} else if (format === 'month_year') {
		dateToDisplay = moment(date).locale($('#locale').data().locale).format('MM') + '/' + moment(date).locale($('#locale').data().locale).format('YYYY');
	} else if (format === 'quarter_year') {
		dateToDisplay = moment(date).locale($('#locale').data().locale).format('Q') + '/' + moment(date).locale($('#locale').data().locale).format('YYYY');
	} else {
		dateToDisplay = dateToLocaleTimeString(date);
	}
	return dateToDisplay;
}

function getMomentFormat(dateFormat) {
	return dateFormat.replace('dd', 'DD').replace('mm', 'MM').replace('yy', 'YYYY');
}

function getLocaleTimeFormat() {
	return moment().locale($('#locale').data().locale)._locale._longDateFormat.LT;
}

function getLocaleNumberString(number, decimals) {

	try {
		return numberToString(stringToNumber(number), decimals);
	} catch (NaNError) {
		return number;
	}
}

function getLocaleNumberFromString(number, decimals) {

	try {
		if (isNaN(parseFloat(number))) {
			return number;
		}
		return numberToString(parseFloat(number), decimals);
	} catch (NaNError) {
		return number;
	}
}

function stringToNumber(value) {
	try {
		if (value === '') {
			return '';
		}
		var options = new JsNumberFormatterLocales.parseOptions($('#locale').data().locale.split('-')[0]);
		return JsNumberFormatter.parseNumberSimple(value, options, false).valueOf();
	} catch (NaNError) {
		throw new NaNError();
	}
}

function numberToString(number, decimals) {
	try {
		if (!isUndefined(decimals) && decimals === 0) {
			number = round(number, 0);
			decimals = null;
		}

		var options = new JsNumberFormatterLocales.formatOptions($('#locale').data().locale.split('-')[0]);
		if (!isUndefined(decimals) && decimals > 0) {
			var decimalsString = '';
			for (var i = 0; i < decimals; i++) {
				decimalsString += '0';
			}
			options.specifyDecimalMask(decimalsString);
		}
		var numberString = JsNumberFormatter.formatNumber(number, options, false);
		if (!/^[0-9]/.test(numberString)) {
			numberString = '0' + numberString;
		}

		return numberString;

	} catch (NaNError) {
		return '';
	}
}

function getDecimalSeparator() {
	var options = new JsNumberFormatterLocales.formatOptions($('#locale').data().locale.split('-')[0]);
	return options['decimalSeperatorStr'];
}

function getSerializedFormData(form) {
	return getSerializedFormDataWithoutIgnore(form, '', false);
}

function getSerializedFormDataWithoutIgnore(form, ignore, addEmptyValues) {
	var arrKeyValuePairs = serializeFormData(form, ignore, addEmptyValues);

	$(form).find('[data-database-table-name]').each(function (i, table) {
		if ($(table).hasClass('tt-accordion')) {
			$(table).find('.tt-accordion-panel').each(function (j, row) {
				arrKeyValuePairs.push($(table).data().databaseTableName + '_rowid__' + $(row).data().rowId + "=" + $(row).data().dataId);
			});
		} else {
			var dataTable = $(table).DataTable();
			for (var l = 0; l < dataTable.data().length; l++) {
				var row = $(dataTable.row(l).node());
				arrKeyValuePairs.push($(table).data().databaseTableName + '_rowid__' + row.data().rowId + "=" + row.data().dataId);
				jQuery.merge(arrKeyValuePairs, serializeFormData(row, ignore, addEmptyValues));
			}
		}
	});


	return arrKeyValuePairs.join("&");
}

function serializeFormData(form, ignore, addEmptyValues) {

	var rCRLF = /\r?\n/g;
	var data = '';
	var ignoreSelector = '[name]';
	var ignoreSelectorDisabled = '';

	if (ignore !== '') {
		ignoreSelector = 'input:not(' + ignore + '),select:not(' + ignore + ')';
		ignoreSelectorDisabled = '[name]:disabled:not(' + ignore + ')';
	}
	//console.time('serialize2');
	var arrKeyValuePairs = [];
	var keyArray = [];
	var selector = ignoreSelector;
	if (ignoreSelectorDisabled !== '') {
		selector = ignoreSelector + ',' + ignoreSelectorDisabled;
	}
	jQuery.each($(form).find(selector), function(i, element) {
		var isRadioCheckbox = $(element).is(':radio') || $(element).is(':checkbox');
		if (!isUndefined(element.name) && element.name !== '') {
			var val = jQuery(this).val();
			if ($(element).hasClass('tt-select2')) {
				val = $(element).select2().val();
			} else if ($(element).hasClass('datepicker') && val.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
				val = '';
			}

			if (val !== null && val !== '' && (!isRadioCheckbox || (isRadioCheckbox && $(element).is(':checked')))) {
				var key = element.name;
				var value = '';
				if (jQuery.isArray(val)) {
					jQuery.map(val, function (val) {
						if (value !== '') {
							value += '|';
						}
						value += val.replace(rCRLF, "\r\n");
					});
				} else {
					value = val.replace(rCRLF, "\r\n");
				}

				if ($(element).hasClass('datepicker')) {
					var picker = $(element).data('picker');
					value = dateToString(picker.getDate());
				}
				if ($(element).hasClass('tt-input-decimal') || $(element).hasClass('tt-currency')) {
					try {
						value = stringToNumber(value);
					} catch (NaNError) {
					}
				}
				if ($(element).length && !isUndefined(element.dataset.calculatedValue) && element.dataset.calculatedValue !== '') {
					try {
						value = stringToNumber(element.dataset.calculatedValue);
					} catch (NaNError) {
					}
				}
				if (keyArray.indexOf(key) >= 0) {
					arrKeyValuePairs = jQuery.grep(arrKeyValuePairs, function(element) {
						var pattern = new RegExp("^" + encodeURIComponent(key) + "=");
						return !pattern.test(element);
					});
				} else {
					keyArray.push(key);
				}
				arrKeyValuePairs.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
			} else {
				if (addEmptyValues) {
					if (keyArray.indexOf(element.name) < 0) {
						arrKeyValuePairs.push(encodeURIComponent(element.name) + "=");
						keyArray.push(element.name);
					}
				}
			}
		}
	});

	//console.timeEnd('serialize4');
	//console.time('serialize5');
	$(form).find('.tt-input-dropdown').each(function () {
		if (ignore !== '') {
			if ($(this).parent().find(ignoreSelector).length === 0) {
				return;
			}
		}
		if ($(this).find('li.active').length) {
			var formatValue = $(this).find('li.active').find('a').data().formatValue;
			var fieldName = $(this).parent().find('input').attr('name');
			var fieldValue = $(this).parent().find('input').val();

			if (fieldValue === '' || formatValue === 'value' || formatValue === 'full') {
				formatValue = '';
			}

			if (/__/.test(fieldName)) {
				var name = fieldName.substring(0, fieldName.indexOf("__"));
				var name_appendix = fieldName.substring(fieldName.indexOf("__"));
				arrKeyValuePairs.push(encodeURIComponent(name + '_format' + name_appendix) + '=' + encodeURIComponent(formatValue));
			} else {
				arrKeyValuePairs.push(encodeURIComponent(fieldName + '_format') + '=' + encodeURIComponent(formatValue));
			}

			if (isFormatValue(formatValue)) {
				arrKeyValuePairs = jQuery.grep(arrKeyValuePairs, function(value) {
					return value.indexOf(encodeURIComponent(fieldName) + '=') !== 0;
				});
				if (addEmptyValues) {
					arrKeyValuePairs.push(encodeURIComponent(fieldName) + '=');
				}
			}
		}
	});

	//console.timeEnd('serialize5');
	return arrKeyValuePairs;
}

function setValueForInputWithDropDownField(element, value, changeDisabledState) {
	if (value !== '') {
		if (value === 'not_collected') {
			setInputNotCollectedValue(element.parent().find('a[data-format-value="' + value + '"]'));
		} else if (value === 'unknown') {
			setInputUnknownValue(element.parent().find('a[data-format-value="' + value + '"]'));
		} else if (value === 'not_measurable') {
			setInputNotMeasurableValue(element.parent().find('a[data-format-value="' + value + '"]'));
		} else if (value === 'continuing') {
			setInputContinuingValue(element.parent().find('a[data-format-value="' + value + '"]'));
		} else if (value === 'unlimited') {
			setInputUnlimitedValue(element.parent().find('a[data-format-value="' + value + '"]'));
		} else {
			if (element.parent().hasClass('tt-datepicker') && element.parent().find('a[data-format-value="' + value + '"]').length) {
				setDatePickerDropDownValue(element.parent().find('a[data-format-value="' + value + '"]'), changeDisabledState);
			} else {
				setInputDropDownValue(element.parent().find('a[data-format-value="' + value + '"]'), changeDisabledState);
			}
		}

		var currentDisplayDecimals = '';
		if (element.parent().find('.tt-input-dropdown').length) {
			if (element.parent().find('li.active').length) {
				currentDisplayDecimals = element.parent().find('li.active').find('a').data().displayDecimals;
			}
		}
		$(element).parents('.input-group').find('input').data('displayDecimals', currentDisplayDecimals);
	}
}

function getValueFromInputWithDropDownField(element) {
	var selected_value = '';

	element.parent().parent().find('.tt-input-dropdown').each(function () {
		if ($(this).find('li.active').length) {
			 selected_value = $(this).find('li.active').find('a').data().formatValue;
			 return false;
		}
	});

	return selected_value;
}

function setDatePickerDropDownValue(element, changeDisabledState) {

	var picker = $($(element).parents('.input-group').find('input')).data('picker');
	var currentDate = picker.getDate();
	var prevFormatValue = $(element).parents('ul.dropdown-menu').find('li.active').find('a').data().formatValue;

	$(element).parents('ul.dropdown-menu').find('li').removeClass('active');
	$(element).parent().addClass('active');

	if (changeDisabledState) {
		$(element).parents('.input-group').find('input').removeAttr('disabled');
	}
	$(element).parents('.input-group').find('input').removeClass('tt-input-disabled');

	if ($(element).hasClass('tt-select-date-full')) {
		$(element).parents('.input-group').find('input').data('dateformat', getLocaleDateFormat());
		$(element).parents('.input-group').find('input').mask(getLocaleDateFormatMask(), { placeholder: '_' });
	} else if ($(element).hasClass('tt-select-date-month-year')) {
		$(element).parents('.input-group').find('input').data('dateformat', 'MM/YYYY');
		$(element).parents('.input-group').find('input').mask('?99/9999', { placeholder: '_' });
	} else if ($(element).hasClass('tt-select-date-year')) {
		$(element).parents('.input-group').find('input').data('dateformat', 'YYYY');
		$(element).parents('.input-group').find('input').mask('?9999', { placeholder: '_' });
	}

	picker.config({ format: $(element).parents('.input-group').find('input').data('dateformat') });

	if (prevFormatValue === 'not_collected' || prevFormatValue === 'unknown' || prevFormatValue === 'continuing' || prevFormatValue === 'unlimited') {
		$(element).parents('.input-group').find('input').val('');
	} else {
		picker.setDate(currentDate);
	}
}

function setDatePickerValue(picker, selectedDate) {
	var format = picker._o.format;

	var currentDateString = complementDateString(selectedDate, format).replace(/_/g, '');
	if (selectedDate.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
		currentDateString = '';
	}

	if (currentDateString !== '' && moment(currentDateString, getMomentFormat(format)).isValid()) {
		picker.setMoment(moment(currentDateString, getMomentFormat(format)));
	} else {
		picker.setDate(null);
		$(picker._o.field).val(currentDateString);
	}
}

function blurDatepicker(element) {
	var picker = $(element).data('picker');
	if (!isUndefined(picker)) {
		picker.hide();
		var selectedDate = $(element).val().replace(/_/g, '');
		if (selectedDate.indexOf('.') >= 0) {
			selectedDate = selectedDate.replace(/\.*$/g, '');
		} else if (selectedDate.indexOf('/') >= 0) {
			selectedDate = selectedDate.replace(/\/*$/g, '');
		}
		setDatePickerValue(picker, selectedDate);
	}

	if ($(element).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
		$(element).removeClass('edited');
	}
}

function setInputDropDownValue(element, changeDisabledState) {

	if (!isUndefined($(element).parents('ul.dropdown-menu').find('li.active').find('a').data())) {
		var prevFormatValue = $(element).parents('ul.dropdown-menu').find('li.active').find('a').data().formatValue;

		$(element).parents('ul.dropdown-menu').find('li').removeClass('active');
		$(element).parent().addClass('active');

		if (changeDisabledState) {
			$(element).parents('.input-group').find('input').removeAttr('disabled');
		}
		$(element).parents('.input-group').find('.input').find('i').text($(element).text());
		if (prevFormatValue === 'not_collected' || prevFormatValue === 'unknown' || prevFormatValue === 'not_measurable') {
			$(element).parents('.input-group').find('input').val('');
		}
		$(element).parents('.input-group').find('input').removeClass('tt-input-disabled');
	}
}

function setInputUnknownValue(element) {
	$(element).parents('ul.dropdown-menu').find('li').removeClass('active');
	$(element).parent().addClass('active');

	$(element).parents('.input-group').find('input').prop('disabled', 'disabled');
	$(element).parents('.input-group').find('input').val(trans('extrax2-webadmin.unknown'));
	$(element).parents('.input-group').find('input').addClass('tt-input-disabled').addClass('edited');
}

function setInputNotCollectedValue(element) {
	$(element).parents('ul.dropdown-menu').find('li').removeClass('active');
	$(element).parent().addClass('active');

	$(element).parents('.input-group').find('input').prop('disabled', 'disabled');
	$(element).parents('.input-group').find('input').val(trans('extrax2-webadmin.not_collected'));
	$(element).parents('.input-group').find('input').addClass('tt-input-disabled').addClass('edited');
}

function setInputNotMeasurableValue(element) {
	$(element).parents('ul.dropdown-menu').find('li').removeClass('active');
	$(element).parent().addClass('active');

	$(element).parents('.input-group').find('input').prop('disabled', 'disabled');
	$(element).parents('.input-group').find('input').val(trans('extrax2-webadmin.not_measurable'));
	$(element).parents('.input-group').find('input').addClass('tt-input-disabled').addClass('edited');
}

function setInputContinuingValue(element) {
	$(element).parents('ul.dropdown-menu').find('li').removeClass('active');
	$(element).parent().addClass('active');

	$(element).parents('.input-group').find('input').prop('disabled', 'disabled');
	$(element).parents('.input-group').find('input').val(trans('extrax2-webadmin.continuing'));
	$(element).parents('.input-group').find('input').addClass('tt-input-disabled').addClass('edited');
}

function setInputUnlimitedValue(element) {
	$(element).parents('ul.dropdown-menu').find('li').removeClass('active');
	$(element).parent().addClass('active');

	$(element).parents('.input-group').find('input').prop('disabled', 'disabled');
	$(element).parents('.input-group').find('input').val(trans('extrax2-webadmin.unlimited'));
	$(element).parents('.input-group').find('input').addClass('tt-input-disabled').addClass('edited');
}

function arrayIntersect(array1, array2) {
	return $.grep(array1, function (i) {
		return $.inArray(i, array2) > -1;
	});
};

function setHtmlData(element, data, doInitializeElements) {
	//console.time('setHtmlData1');
	element.empty();
	element.html(data);
	setFormatValues(element);

	if (doInitializeElements) {
		initialize.initializeElements(element);
	}

	setPortletMaxHeight();
	setDetailPortletMaxHeight();
	//console.timeEnd('setHtmlData3');

	App.unblockUI('body');
}

function setFormatValues(element) {
	element.find('.tt-input-decimal').each(function () {
		if ($(this).val() !== '') {
			$(this).val(numberToString(parseFloat($(this).val())));
		}
	});
	element.find('.tt-format-t').each(function () {
		$(this).text(dateToLocaleTimeString(parseInt($(this).text()), false));
	});
	element.find('.tt-format-d').each(function () {
		if ($(this).hasClass('tt-time')) {
			$(this).text(dateToLocaleTimeString($(this).text(), false));
		} else {
			$(this).text(dateToLocaleString($(this).text()));
		}
	});
	element.find('.tt-format-long-d').each(function () {
		if ($(this).is('input')) {
			$(this).val(dateToLocaleLongTimeString($(this).val(), false));
		} else {
			$(this).text(dateToLocaleLongTimeString($(this).text(), false));
		}
	});
	element.find('.tt-format-d-mm-yy').each(function () {
		$(this).text(dateToLocaleFormatString($(this).text(), 'MM/YYYY'));
	});
	element.find('.tt-format-d-yy').each(function () {
		$(this).text(dateToLocaleFormatString($(this).text(), 'YYYY'));
	});
	element.find('.tt-format-n').each(function () {
		$(this).text(numberToString(parseFloat($(this).text())));
	});
	element.find('.tt-format-currency').each(function () {
		$(this).text(numberToString(parseFloat($(this).text()), 2) + ' €');
	});
	element.find('.tt-currency').each(function () {
		if ($(this).val().length) {
			$(this).val(numberToString(parseFloat($(this).val()), 2));
		}
	});
}

function setDetailPortletMaxHeight() {

	if ($('#content-detail .portlet .tab-content-detail').length) {
		var maxHeight = 0;
		jQuery.each($('#content-detail .portlet .tab-content-detail .tab-pane'), function(i, element) {
			if ($(element).height() > maxHeight) {
				maxHeight = $(element).height();
			}
		});
		$('#content-detail .portlet .tab-content-detail')[0].style.height = maxHeight + "px";
	}
}

function setPortletMaxHeight() {

	if ($('#content .portlet .tab-content-data').length) {
		var maxHeight = 0;
		jQuery.each($('#content .portlet .tab-content-data .tab-pane'), function(i, element) {
			if ($(element).height() > maxHeight) {
				maxHeight = $(element).height();
			}
		});
		$('#content .portlet .tab-content-data')[0].style.height = maxHeight + "px";
	}
	if ($('#content .portlet .tab-content-contract').length) {
		var maxHeight = 0;
		jQuery.each($('#content .portlet .tab-content-contract .tab-pane'), function(i, element) {
			if ($(element).height() > maxHeight) {
				maxHeight = $(element).height();
			}
		});
		$('#content .portlet .tab-content-contract')[0].style.height = maxHeight + "px";
	}
}

function resizeBackgroundImage() {
	if ($('.about-header').length) {
		var screenHeight = $(window).height() - 305;
		// console.log(screenHeight);
		$('.about-header')[0].style.height = screenHeight + "px";
	}
}

function handleContentHeight() {
	var height;

	height = App.getViewPort().height -
		$('.page-header').outerHeight() -
		($('.page-container').outerHeight() - $('.page-content').outerHeight()) -
		$('.page-prefooter').outerHeight() -
		$('.page-footer').outerHeight();

	$('.page-content').css('min-height', height);
}

function isIDATField(matchFieldName) {

	var idatFields = ['patientname', 'street', 'prename', 'city' ,'birth_name', 'postal_code', 'birth_date', 'birth_city', 'gender'];
	return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isIDATFieldInDatabase(matchFieldName) {

	var idatFields = ['patientname', 'street', 'prename', 'city' ,'birth_name', 'postal_code', 'birth_city'];
	return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isIDATInputField(matchFieldName) {
	var idatFields = ['patientname', 'street', 'prename', 'city' ,'birth_name', 'postal_code', 'birth_city'];
	return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isIDATRadioComboField(matchFieldName) {
	var idatFields = ['gender'];
	return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isIDATDatePanelField(matchFieldName) {
	var idatFields = ['birth_date'];
	return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isMatchFieldInDatabase(matchFieldName) {

	var matchFields = ['state'];
	return jQuery.inArray(matchFieldName, matchFields) !== -1;
}

function getIgnoreFields() {

	return '[data-match-field="patientname"],[data-match-field="street"],[data-match-field="prename"],[data-match-field="city"],[data-match-field="birth_name"],[data-match-field="postal_code"],[data-match-field="birth_date"],[data-match-field="birth_city"],[data-match-field="gender"]';
}

function getIgnoreFieldsNameArray() {

	if (this.ignoreFieldsNameArray.length === 0) {
		if ($('[data-match-field="patientname"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="patientname"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="patientname"]').attr('name') + '_format');
		}
		if ($('[data-match-field="street"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="street"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="street"]').attr('name') + '_format');
		}
		if ($('[data-match-field="prename"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="prename"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="prename"]').attr('name') + '_format');
		}
		if ($('[data-match-field="city"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="city"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="city"]').attr('name') + '_format');
		}
		if ($('[data-match-field="birth_name"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="birth_name"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="birth_name"]').attr('name') + '_format');
		}
		if ($('[data-match-field="postal_code"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="postal_code"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="postal_code"]').attr('name') + '_format');
		}
		if ($('[data-match-field="birth_date"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="birth_date"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="birth_date"]').attr('name') + '_format');
		}
		if ($('[data-match-field="birth_city"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="birth_city"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="birth_city"]').attr('name') + '_format');
		}
		if ($('[data-match-field="gender"]').length) {
			this.ignoreFieldsNameArray.push($('[data-match-field="gender"]').attr('name'));
			this.ignoreFieldsNameArray.push($('[data-match-field="gender"]').attr('name') + '_format');
		}
	}
	return this.ignoreFieldsNameArray;
}

function isFormatValue(value) {

	var formatValues = ['unknown', 'not_collected', 'continuing', 'not_measurable', 'unlimited'];
	return jQuery.inArray(value, formatValues) !== -1;
}

function htmlSpecialChars(string) {

	var map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#039;',
		'ä': '&auml;',
		'ü': '&uuml;',
		'ö': '&ouml;',
		'Ä': '&Auml;',
		'Ü': '&Uuml;',
		'Ö': '&Ouml;',
		'ß': '&szlig;'
	};

	return string.replace(/[&<>"']/g, function(string) { return map[string]; });
}

function isIgnoreFlagForIntegrityCheck(flagName) {

	var ignoreFlagNames = ['import', 'integrity_check'];
	return jQuery.inArray(flagName, ignoreFlagNames) !== -1;
}

function resetForm(element) {

	if (!$(element).find('form').hasClass('tt-no-reset-form')) {

		this.GLOBALS['programmaticChange'] = true;
		$(element).find('form').validate().resetForm();
		$(element).find('form').find('input').removeClass('edited');

		if (!$(element).find('form').hasClass('tt-no-reset-hidden-input')) {
			$(element).find('form').find('input[type="hidden"]:not([data-no-reset="no-reset-value"])').val('');
		}

		if ($(element).find('.tt-select2:not(.tt-no-reset-select2)').length) {
			jQuery.each($(element).find('.tt-select2:not(.tt-no-reset-select2)'), function (i, select2) {
				$(select2).val(null).trigger('change');
			});
			$('#m_ident_pvs_id').select2({
				placeholder: trans('extrax2-webadmin.pvs')
			});
			$('#m_ident').select2({
				placeholder: trans('extrax2-webadmin.ident')
			});
			// $(element).find('.tt-select2:not(.tt-no-reset-select2)').removeAttr('disabled');
			$(element).find('.tt-select2:not(.tt-no-reset-select2)').parents('.form-md-select2').removeClass('edited');
		}

		if ($(element).find('.datepicker').length) {
			jQuery.each($(element).find('.datepicker'), function (i, datepicker) {
				$(datepicker).data('picker').setDate(null);
			});
		}

		$(element).find('.mt-element-list .mt-list-container ul li').remove();
		this.GLOBALS['programmaticChange'] = false;
	}
}

module.exports.isUndefined = isUndefined;
module.exports.updateGlobals = updateGlobals;
module.exports.dateToString = dateToString;
module.exports.dateToTimeString = dateToTimeString;
module.exports.dateToTimepickerString = dateToTimepickerString;
module.exports.stringToDate = stringToDate;
module.exports.stringToUTCDate = stringToUTCDate;
module.exports.getSerializedFormData = getSerializedFormData;
module.exports.getSerializedFormDataWithoutIgnore = getSerializedFormDataWithoutIgnore;
module.exports.setValueForInputWithDropDownField = setValueForInputWithDropDownField;
module.exports.getValueFromInputWithDropDownField = getValueFromInputWithDropDownField;
module.exports.setDatePickerDropDownValue = setDatePickerDropDownValue;
module.exports.setInputDropDownValue = setInputDropDownValue;
module.exports.setInputUnknownValue = setInputUnknownValue;
module.exports.setInputNotCollectedValue = setInputNotCollectedValue;
module.exports.setInputContinuingValue = setInputContinuingValue;
module.exports.setInputNotMeasurableValue = setInputNotMeasurableValue;
module.exports.setInputUnlimitedValue = setInputUnlimitedValue;
module.exports.arrayIntersect = arrayIntersect;
module.exports.calculateAge = calculateAge;
module.exports.round = round;
module.exports.dateToLocaleFormatString = dateToLocaleFormatString;
module.exports.dateToLocaleString = dateToLocaleString;
module.exports.dateToLocaleTimeString = dateToLocaleTimeString;
module.exports.dateToLocaleLongTimeString = dateToLocaleLongTimeString;
module.exports.getLocaleDateFormat = getLocaleDateFormat;
module.exports.getLocaleTimeFormat = getLocaleTimeFormat;
module.exports.getLocaleDateFormatMask = getLocaleDateFormatMask;
module.exports.getMomentFormat = getMomentFormat;
module.exports.getLocaleNumberString = getLocaleNumberString;
module.exports.getLocaleNumberFromString = getLocaleNumberFromString;
module.exports.stringToNumber = stringToNumber;
module.exports.numberToString = numberToString;
module.exports.setHtmlData = setHtmlData;
module.exports.isIDATField = isIDATField;
module.exports.isIDATFieldInDatabase = isIDATFieldInDatabase;
module.exports.isMatchFieldInDatabase = isMatchFieldInDatabase;
module.exports.isIDATInputField = isIDATInputField;
module.exports.isIDATRadioComboField = isIDATRadioComboField;
module.exports.isIDATDatePanelField = isIDATDatePanelField;
module.exports.isFormatValue = isFormatValue;
module.exports.htmlSpecialChars = htmlSpecialChars;
module.exports.getIgnoreFields = getIgnoreFields;
module.exports.getIgnoreFieldsNameArray = getIgnoreFieldsNameArray;
module.exports.getDecimalSeparator = getDecimalSeparator;
module.exports.getExaminationDateString = getExaminationDateString;
module.exports.getExaminationDateFormat = getExaminationDateFormat;
module.exports.complementDateString = complementDateString;
module.exports.complementTimeString = complementTimeString;
module.exports.setDatePickerValue = setDatePickerValue;
module.exports.isIgnoreFlagForIntegrityCheck = isIgnoreFlagForIntegrityCheck;
module.exports.resetForm = resetForm;
module.exports.blurDatepicker = blurDatepicker;
module.exports.setDetailPortletMaxHeight = setDetailPortletMaxHeight;
module.exports.setPortletMaxHeight = setPortletMaxHeight;
module.exports.setFormatValues = setFormatValues;
module.exports.resizeBackgroundImage = resizeBackgroundImage;
module.exports.handleContentHeight = handleContentHeight;
